<template>
  <div class="huawei-download-explanation-wrap page-wrap">
    <div class="top">
      <img src="@/assets/img/logo.png" class="logo">
      <div class="title">{{ $t('huawei.title') }}</div>
      <div class="sub-title">
        {{ $t('huawei.subTitle') }}
      </div>
    </div>

    <div class="content-wrap">
      <WrapperExplanationBlock
        v-for="(item, index) in explanationContentList"
        :key="item.title"
        :title="item.title"
        :content="item.content"
        :isStepOne="index === 0"
        :imgList="item.imgList"
      />
    </div>

    <div class="copyright">
      &copy;
      {{$t('auth')}}
    </div>
  </div>
</template>


<script>
import URI from 'urijs';

import WrapperExplanationBlock from './components/explanation-block.vue';

import StepTwoWithOne from '@/assets/img/huawei-download-explanation/step-2-1.png';
import StepTwoWithOneEn from '@/assets/img/huawei-download-explanation/step-2-1-en.png';
import StepTwoWithTwo from '@/assets/img/huawei-download-explanation/step-2-2.png';
import StepTwoWithTwoEn from '@/assets/img/huawei-download-explanation/step-2-2-en.png';
import StepThreeWithOne from '@/assets/img/huawei-download-explanation/step-3-1.png';
import StepThreeWithTwo from '@/assets/img/huawei-download-explanation/step-3-2.png';
import StepThreeWithTwoEn from '@/assets/img/huawei-download-explanation/step-3-2-en.png';
import StepFourWithOne from '@/assets/img/huawei-download-explanation/step-4-1.png';
import StepFourWithOneEn from '@/assets/img/huawei-download-explanation/step-4-1-en.png';
import StepFourWithTwo from '@/assets/img/huawei-download-explanation/step-4-2.png';
import StepFourWithTwoEn from '@/assets/img/huawei-download-explanation/step-4-2-en.png';
import StepFourWithThree from '@/assets/img/huawei-download-explanation/step-4-3.png';
import StepFourWithThreeEn from '@/assets/img/huawei-download-explanation/step-4-3-en.png';
import StepFourWithFour from '@/assets/img/huawei-download-explanation/step-4-4.png';
import StepFourWithFourEn from '@/assets/img/huawei-download-explanation/step-4-4-en.png';
import valueByLocale from '@/helps/value-by-locale';


export default {
  name: 'HuaweiDownloadExplanation',

  components: {
    WrapperExplanationBlock,
  },

  data() {
    return {
      explanationContentList: [
        {
          title: this.$t('huawei.explanationTitleOne'),
          content: this.$t('huawei.explanationContentOne'),
        },

        {
          title: this.$t('huawei.explanationTitleTwo'),
          content: this.$t('huawei.explanationContentTwo'),
          imgList: [
            valueByLocale(StepTwoWithOne, StepTwoWithOneEn),
            valueByLocale(StepTwoWithTwo, StepTwoWithTwoEn),
          ],
        },
        {
          title: this.$t('huawei.explanationTitleThree'),
          content: this.$t('huawei.explanationContentThree', {
            link: process.env.WEMUST_APP_DOWNLOAD_PAGE_URL,
            jumpUrl: this.getWemustDownloadPageUrlWithLocale(),
          }),
          imgList: [
            valueByLocale(StepThreeWithOne, StepThreeWithOne),
            valueByLocale(StepThreeWithTwo, StepThreeWithTwoEn),
          ],
        },
        {
          title: this.$t('huawei.explanationTitleFour'),
          content: this.$t('huawei.explanationContentFour'),
          imgList: [
            valueByLocale(StepFourWithOne, StepFourWithOneEn),
            valueByLocale(StepFourWithTwo, StepFourWithTwoEn),
            valueByLocale(StepFourWithThree, StepFourWithThreeEn),
            valueByLocale(StepFourWithFour, StepFourWithFourEn),
          ],
        },
      ],
    };
  },

  methods: {
    getWemustDownloadPageUrlWithLocale() {
      const url = new URI(process.env.WEMUST_APP_DOWNLOAD_PAGE_URL);
      url.addSearch('locale', this.$i18n.locale);

      return url.toString();
    },
  },
};
</script>


<style lang="less" scoped>
.huawei-download-explanation-wrap {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0 auto;

  .top {
    display: flex;
    flex-direction: column;
    align-items: center;
    box-sizing: border-box;
    width: 100%;
    margin: 54px 0 65px;
    text-align: center;

    .logo {
      width: 64px;
      height: 64px;
      margin: 9px 0 12px;
    }

    .title {
      color: #222;
      font-size: 20px;
      font-weight: 500;
      line-height: normal;
    }

    .sub-title {
      margin-top: 4px;
      color: #444;
      font-weight: 300;
      font-size: 15px;
      line-height: normal;
    }
  }

  .content-wrap {
    box-sizing: border-box;
    width: 100%;
    max-width: 680px;
    padding: 0 20px;
  }

  .copyright {
    padding: 31px 0 20px;
    padding-bottom: calc(constant(safe-area-inset-bottom) + 20px);
    padding-bottom: calc(env(safe-area-inset-bottom) + 20px);
    color: #888;
    font-size: 12px;
    font-weight: 400;
    line-height: normal;
    text-align: center;
  }
}
</style>
